<template>
  <div class="animated fadeIn">
    <div class="title font-300 font-24 mb-15">
      {{this.$route.name}}
    </div>
    <div class="box">
      <div class="p-15 pb-0">
        <div class="row">
          <div class="col-6">
            <a
              @click="openPage('/event')"
              class="btn-grey"
            ><i class="fas fa-arrow-circle-left mr-5"></i>Back</a>
          </div>
        </div>
      </div>
      <hr class="mb-0">
      <div class="p-15 pt-0">
        <div class="row justify-content-center mt-30">
          <div class="col-sm-10">
            <form @submit.prevent="validateRegister">
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Name</label>
                </b-col>
                <b-col sm="10">
                  <b-form-input
                    v-model="name"
                    name="name"
                    v-validate="'required'"
                    type="text"
                  ></b-form-input>
                  <span class="error">{{ errors.first('name') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Event Date</label>
                </b-col>
                <b-col sm="10">
                  <flat-pickr
                    :config="config"
                    v-model="event_date"
                    name="event_date"
                    v-validate="'required'"
                    class="w-100"
                  ></flat-pickr>
                  <span class="error">{{ errors.first('event_date') }}</span>
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="status">Studio</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select
                    name="studio"
                    @change="changeClass"
                    v-model="studio_id"
                  >
                    <option :value="null">Please select</option>
                    <option
                      v-for="(item, index) in optStudio"
                      :value="item.id"
                      :key="index"
                    >{{item.name}}</option>
                  </b-form-select>
                  <!-- v-validate="'required'"
                  <span class="error">{{ errors.first('studio') }}</span> -->
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="status">Classes Name</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select
                    name="classes_name"
                    v-model="classes_id"
                  >
                    <option :value="null">Please select</option>
                    <option
                      v-for="item in optClasses"
                      :key="item.id"
                      :value="item.id"
                    >{{item.name}}</option>
                  </b-form-select>
                  <!-- v-validate="'required'"
                  <span class="error">{{ errors.first('classes_name') }}</span> -->
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Promo Code</label>
                </b-col>
                <b-col sm="10">
                  <b-form-select
                    name="promo_code"
                    v-model="promo_code_id"
                  >
                    <option :value="null">Please select</option>
                    <option
                      v-for="item in optPromoCode"
                      :key="item.id"
                      :value="item.id"
                    >{{item.name}}</option>
                  </b-form-select>
                  <!-- v-validate="'required'"
                  <span class="error">{{ errors.first('promo_code') }}</span> -->
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="image_gallery">Image</label>
                </b-col>
                <b-col sm="10">
                  <b-form-file
                    name="file"
                    @change="previewImage"
                    accept="image/*"
                    v-model="file"
                    :state="Boolean(file)"
                    placeholder="Choose a file..."
                  ></b-form-file>
                  <!-- <div class="mt-3">Selected file: {{file && file.name}}</div> -->
                  <div
                    class="image-preview"
                    v-if="imageData.length > 0"
                  >
                    <img
                      class="preview"
                      :src="imageData"
                    >
                  </div>
                  <!-- v-validate="'required'"
                  <span class="error">{{ errors.first('file') }}</span> -->
                </b-col>
              </b-row>
              <div class="font-bold">ENGLISH</div>
              <hr class="mt-5">
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Description</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <quill-editor
                      class="editor-custom"
                      name="description_en"
                      ref="myTextEditor"
                      v-model="description_en"
                      :config="editorOption"
                    ></quill-editor>
                  </div>
                  <!-- v-validate="'required'"
                  <span class="error">{{ errors.first('description_en') }}</span> -->
                </b-col>
              </b-row>
              <div class="font-bold">INDONESIA</div>
              <hr class="mt-5">
              <b-row class="mb-20">
                <b-col sm="2">
                  <label>Description</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <quill-editor
                      class="editor-custom"
                      name="description_id"
                      ref="myTextEditor"
                      v-model="description"
                      :config="editorOption"
                    ></quill-editor>
                  </div>
                  <!-- v-validate="'required'"
                  <span class="error">{{ errors.first('description_id') }}</span> -->
                </b-col>
              </b-row>
              <b-row class="mb-20">
                <b-col sm="2">
                  <label for="status_gallery">Status</label>
                </b-col>
                <b-col sm="10">
                  <div>
                    <b-form-select
                      name="status"
                      v-validate="'required'"
                      v-model="status"
                      :options="options"
                    />
                  </div>
                  <span class="error">{{ errors.first('status') }}</span>
                </b-col>
              </b-row>
              <div class="text-right">
                <button
                  type="submit"
                  class="btn-primary"
                >Submit</button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { Callout } from "@coreui/vue";
import axios from "axios";
import { Auth } from "@/api";
import { quillEditor } from "vue-quill-editor";

export default {
  name: "addEvent",
  data: function() {
    return {
      editorOption: {
        // modules: {
        //   toolbar: [
        //     ['bold', 'italic', 'underline', 'strike'],
        //     ['blockquote', 'code-block'],
        //     [{ 'header': 1 }, { 'header': 2 }, { 'header': 3 }],
        //   ]
        // }
      },
      config: {
        mode: "range",
        altInput: true,
        altFormat: "F j, Y",
        dateFormat: "Y-m-d"
      },
      imageData: "",
      name: "",
      description: "",
      description_en: "",
      event_date: "",
      start_date: "",
      end_date: "",
      studio_id: null,
      classes_id: null,
      promo_code_id: null,
      status: null,
      file: "",
      options: [
        { value: null, text: "Please select" },
        { value: "active", text: "Active" },
        { value: "inactive", text: "Inactive" }
      ],
      optStudio: [],
      optClasses: [],
      optPromoCode: []
    };
  },
  components: {
    quillEditor
  },
  methods: {
    validateRegister() {
      this.$validator.validateAll().then(result => {
        if (result) {
          axios.defaults.headers.common[
            "X-Access-Token"
          ] = Auth.Session.get().paradigm_token;
          axios.defaults.headers.post["Content-Type"] = "multipart/form-data";
          var data = new FormData();
          data.append("name", this.name);
          data.append("description", this.description);
          data.append("description_en", this.description_en);
          // data.append('event_date', this.event_date)
          var date = this.event_date.split(" to ");
          data.append("start_date", date[0]);
          data.append("end_date", date[1]);
          data.append("studio_id", this.studio_id);
          data.append("classes_id", this.classes_id);
          data.append("promo_code_id", this.promo_code_id);
          data.append("status", this.status);
          data.append("photos", this.file);
          axios
            .post("compro/v1/events", data)
            .then(response => {
              // console.log('test', response)
              this.$router.push("/event");
              this.$toast.success("data saved successfully!", "Success", {
                position: "topCenter",
                icon: "icon-envelope",
                progressBarColor: "rgb(0, 255, 184)",
                theme: "dark",
                backgroundColor: "#565c70",
                messageColor: "#fff"
              });
            })
            .catch(error => {
              // console.log('error', error)
              this.$toast.success("cant saved data!", "Error", {
                position: "topCenter",
                icon: "icon-envelope",
                progressBarColor: "rgb(0, 255, 184)",
                theme: "dark",
                backgroundColor: "#565c70",
                messageColor: "#fff"
              });
            });
        } else {
          this.$toast.success("please fill in required fields!", "Error", {
            position: "topCenter",
            icon: "icon-envelope",
            progressBarColor: "rgb(0, 255, 184)",
            theme: "dark",
            backgroundColor: "#565c70",
            messageColor: "#fff"
          });
        }
      });
    },
    openPage(event) {
      this.$router.push(event);
    },
    previewImage: function(event) {
      // Reference to the DOM input element
      var input = event.target;
      // Ensure that you have a file before attempting to read it
      if (input.files && input.files[0]) {
        // create a new FileReader to read this image and convert to base64 format
        var reader = new FileReader();
        // Define a callback function to run, when FileReader finishes its job
        reader.onload = e => {
          // Note: arrow function used here, so that "this.imageData" refers to the imageData of Vue component
          // Read image as base64 and set to imageData
          this.imageData = e.target.result;
        };
        // Start the reader job - read file as a data url (base64 format)
        reader.readAsDataURL(input.files[0]);
      }
    },
    changeClass(event) {
      // console.log(event)
      axios
        .get("fitness/v1/classes?studio_id=" + event)
        .then(response => {
          this.optClasses = response.data.data.rows;
          // console.log('test', response.data.data.rows)
        })
        .catch(error => {
          console.log("error", error);
        });
    },
    fetchData() {
      axios.defaults.headers.common[
        "X-Access-Token"
      ] = Auth.Session.get().paradigm_token;
      axios
        .get("fitness/v1/classes?studio_id=" + event)
        .then(response => {
          this.optClasses = response.data.data.rows;
          // console.log('test', response.data.data.rows)
        })
        .catch(error => {
          console.log("error", error);
        });
      axios
        .get("fitness/v1/studio?sorting=id&sorting_type=asc")
        .then(response => {
          this.optStudio = response.data.data.rows;
          // console.log('test', response.data.data.rows)
        })
        .catch(error => {
          console.log("error", error);
        });
      axios
        .get("fitness/v1/promo_code?sorting=id&sorting_type=asc")
        .then(response => {
          this.optPromoCode = response.data.data.rows;
          // console.log('test', response.data.data.rows)
        })
        .catch(error => {
          console.log("error", error);
        });
    }
  },
  created() {
    this.fetchData();
  }
};
</script>

<style>
</style>
